import { useEffect } from 'react';
import { useRouter } from 'next/router';

import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

//Hooks
// import useToggle from '@/utils/hooks/utils/useToggle';
// import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

export const GLOBAL_EVENT_QUERY = 'global_event';
export const GLOBAL_EVENT_TYPES = {};

const GlobalEventsListener = () => {
    // const { activeSocialProfile } = useActiveSocialProfile();

    const router = useRouter();
    const { clearUrlQueriesWithoutReload } = useRouterQuery();
    const { [GLOBAL_EVENT_QUERY]: globalEvent, errors } = router.query;

    useEffect(() => {
        if (!globalEvent) {
            return;
        }
        switch (globalEvent) {
            default:
                break;
        }
        clearUrlQueriesWithoutReload();
    }, [globalEvent]);

    useEffect(() => {
        if (!errors) {
            return;
        }
        // clear url
        clearUrlQueriesWithoutReload();
    }, [errors]);

    return null;
};

export default GlobalEventsListener;
